// extracted by mini-css-extract-plugin
export default {"note":"Note_note__GAUd5","note-title":"Note_note-title__OEET6","note-details":"Note_note-details__Ort0h","note-date":"Note_note-date__V1vj6","note-footer":"Note_note-footer__guSPB"};